import React from "react";
import { useTranslation } from "react-i18next";

import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Link from "@mui/material/Link";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Button from "../../components/Button";

const CoursesGroupItem = ({ onEdit, onDelete, group }) => {
  const { t } = useTranslation();
  const groupCoursesList = (
    <ul>
      {group.groupCourses
        .sort((a, b) => a.startDate - b.startDate)
        .map((course) => (
          <li key={course.id} style={{ opacity: course.visible ? 1 : 0.5 }}>
            ({course.id}) {course.name}
          </li>
        ))}
    </ul>
  );
  return (
    <TableRow>
      <TableCell>{group.id}</TableCell>
      <TableCell>{group.groupName}</TableCell>
      <TableCell>{groupCoursesList}</TableCell>
      <TableCell>
        <Link style={{ marginRight: "1rem" }} onClick={() => onEdit(group.id)}>
          <Button title={t("course_groups.edit_action")} icon={<EditIcon />} />
        </Link>
        <Link onClick={() => onDelete(group.id)}>
          <Button title={t("course_groups.delete_action")} icon={<DeleteForeverIcon color="error" />} />
        </Link>
      </TableCell>
    </TableRow>
  );
};

export default CoursesGroupItem;
